import type { ITicketCommercialLoanFees } from './TicketCommercialLoanFees.interface';

export default class TicketCommercialLoanFees implements ITicketCommercialLoanFees {
  valuation: number;
  solicitor: number;
  settlement: number;
  package: number;
  packageMonthly: number;
  rate: number;
  other: number;
  application: number;

  static build = (data: ITicketCommercialLoanFees) => new TicketCommercialLoanFees(data);
  static blank = () => new TicketCommercialLoanFees();

  /**
   * Constructor
   * @param {ITicketCommercialLoanFees} data
   */
  constructor(data?: ITicketCommercialLoanFees) {
    this.valuation = parseInt(data?.valuation || 0, 10);
    this.solicitor = parseInt(data?.solicitor || 0, 10);
    this.settlement = parseInt(data?.settlement || 0, 10);
    this.package = parseInt(data?.package || 0, 10);
    this.packageMonthly = parseInt(data?.packageMonthly || 0, 10);
    this.rate = parseInt(data?.rate || 0, 10);
    this.other = parseInt(data?.other || 0, 10);
    this.application = parseInt(data?.application || 0, 10);
  }
}
